import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";

import { type Applicant, type UpdateApplicantInput } from "src/app/schema";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class ApplicantService {
	private readonly _httpClient = inject(HttpClient);

	public getApplicationIdentificationNumber(
		applicantId: string,
	): Observable<{ identificationNumber?: string | null }> {
		return this._httpClient.get<{ identificationNumber?: string | null }>(
			`${environment.applicationsEndpoint}/applicant/${applicantId}/identification`,
		);
	}

	public updateApplicant(
		applicant: UpdateApplicantInput,
	): Observable<Applicant> {
		return this._httpClient.put<Applicant>(
			`${environment.applicationsEndpoint}/applicant`,
			applicant,
		);
	}
}
